<template>
    <RouterLink
        to="#product-reviews"
        class="reviews-aggregate"
        @click.prevent.stop="track"
    >
        <ReviewRating :rating="data.rating" />

        <div class="rating">
            {{ rating }}
        </div>
    </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ReviewsAggregateFragment } from '@/graphql/api'

import { useSegment } from '@/third-party/segment'
import { getWindow } from '@/helpers/globals'

import ReviewRating from './ReviewRating.vue'

const { is3rdStep = undefined, data } = defineProps<{
    data: ReviewsAggregateFragment
    is3rdStep?: boolean
}>()

const rating = computed(
    () => `${data.rating.toFixed(1)} (${data.total} reviews)`
)

const { track: segmentTrack } = useSegment()

const ringBuilderStep = computed<'Not applicable' | 'Step 1' | 'Step 3'>(() => {
    if (is3rdStep === undefined) {
        return 'Not applicable'
    }

    return is3rdStep ? 'Step 3' : 'Step 1'
})

const track = () => {
    const url = getWindow()?.location.href

    if (!url) {
        return
    }

    const event_name = 'product_rating_click'

    segmentTrack(`custom_${event_name}`, {
        param1: 'Product Ratings Summary',
        param2: ringBuilderStep.value,
        param3: rating.value,
        param4: url,
        url,
        event_name,
    })
}
</script>

<style scoped>
.reviews-aggregate {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
